import type { KeyValue } from '../redux/api/web-api'
import findOcppConfig from '../../lib/findOcppConfig'

export const hasFeature = (feature: string, configKeys?: KeyValue[] | null): boolean => {
    if (!configKeys) return false
    const config = findOcppConfig('SupportedFeatureProfiles', configKeys)

    if (!config) return false

    const features = config.split(',')
    if (features.find((r) => r === feature)) return true
    return false
}
